// extracted by mini-css-extract-plugin
export var falconContainer = "_w8-2";
export var offerCenter = "_w8-0";
export var roktContainer = "_w8-1";